import { appApiSlice } from "src/api/app-ApiSlice";
import { TAG_STRIPE_SUBSCRIPTION } from "src/api/api-tags";

export interface CreateStripeSubscriptionResponse {
    url: string;
    [key: string]: any;
}

export interface ValidatePaymentCouponResponse {
    valid_register_coupon: boolean;
    valid_payment_subscription_coupon: boolean;
    error_message: string;
    coupon: any;
    new_prices: Record<string, any>;
}

export const paymentApiSlice = appApiSlice.injectEndpoints({
    endpoints: builder => ({
        cancelStripeSubscription: builder.mutation<void, void>({
            query: () => ({
                url: 'v1/payment/cancel-stripe-subscription',
                method: 'POST',
            }),
            invalidatesTags: [TAG_STRIPE_SUBSCRIPTION]
        }),
        createStripeSubscription: builder.mutation<CreateStripeSubscriptionResponse, { redirectToUI?: boolean }>({
            query: ({ redirectToUI = false }) => ({
                url: `v1/payment/create-stripe-subscription?redirectToUI=${redirectToUI}`,
                method: "GET",
            }),
            invalidatesTags: [TAG_STRIPE_SUBSCRIPTION],
        }),
        createStripePayment: builder.mutation<CreateStripeSubscriptionResponse, { monthQuantity: number; redirectToUI?: boolean }>({
            query: ({ monthQuantity, redirectToUI = false }) => ({
                url: `v1/payment/create-stripe-payment?monthQuantity=${monthQuantity}&redirectToUI=${redirectToUI}`,
                method: "GET",
            }),
            invalidatesTags: [TAG_STRIPE_SUBSCRIPTION],
        }),
        changeSubscriptionBankCard: builder.mutation<string, void>({
            query: () => ({
                url: 'v1/payment/change-subscription-bank-card',
                method: 'POST',
            }),
            invalidatesTags: [TAG_STRIPE_SUBSCRIPTION],
        }),
        validatePaymentCoupon: builder.mutation<ValidatePaymentCouponResponse, { couponCode: string }>({
            query: (body) => ({
                url: 'v1/payment/validate-payment-coupon',
                method: 'POST',
                body,
            }),
            invalidatesTags: [TAG_STRIPE_SUBSCRIPTION],
        }),
        saveStripeCheckout: builder.mutation<boolean, { sessionId: string }>({
            query: ({ sessionId }) => ({
                url: `v1/payment/save-stripe-checkout`,
                method: 'GET',
                params: { sessionId },
            }),
            invalidatesTags: [TAG_STRIPE_SUBSCRIPTION],
        }),
        unactivateStripeSession: builder.mutation<boolean, { sessionId: string }>({
            query: ({ sessionId }) => ({
                url: `v1/payment/unactivate-stripe-session`,
                method: 'GET',
                params: { sessionId },
            }),
            invalidatesTags: [TAG_STRIPE_SUBSCRIPTION],
        }),
    }),
});

export const {
    useCancelStripeSubscriptionMutation,
    useCreateStripeSubscriptionMutation,
    useCreateStripePaymentMutation,
    useChangeSubscriptionBankCardMutation,
    useValidatePaymentCouponMutation,
    useSaveStripeCheckoutMutation,
    useUnactivateStripeSessionMutation
} = paymentApiSlice;
